import script from "./transferModal.vue?vue&type=script&setup=true&lang=js"
export * from "./transferModal.vue?vue&type=script&setup=true&lang=js"

import "./transferModal.vue?vue&type=style&index=0&id=3e905800&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e905800"]])

export default __exports__